<div class="flex items-center px-4 h-[64px]">
    <span class="font-bebas text-5xl leading-[0.8] translate-y-[4px]">BRUISED EARS</span>
</div>